<template>
  
      <div class="appie-how-it-work-area pt-10 pb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="how-it-work-thumb text-center">
                        <img src="@/assets/images/how-it-work-thumb.png" alt="">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="appie-how-it-work-content">
                        <h2 class="title">How It works</h2>
                        <p>The little rotter harry butty lurgy spend a peny spiffing skive off golly gosh baking cakes.</p>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="how-it-work-box">
                                    <span>1</span>
                                    <h5 class="title">Download <br> the app</h5>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="how-it-work-box">
                                    <span>2</span>
                                    <h5 class="title">Create a <br> free account</h5>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="how-it-work-box">
                                    <span>3</span>
                                    <h5 class="title">Sync across <br> All devices</h5>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="how-it-work-box">
                                    <span>4</span>
                                    <h5 class="title">Monthly & <br> weekly reports</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>